export default __webpack_public_path__ + "static/media/loader.6cf1d918.gif";